// extracted by mini-css-extract-plugin
export default {"AdditionalNotes":"aP0wG4gYMV1a9DkRQXM4","ListItem":"i9wlvNVuWbylE7X2dCST"};